import { OTHER_PAYMENT_WAY_CODE, PAYMENT_METHODS } from "@utils/Constants";

/**
 * Codigo interno de forma de pago a partir del codigo ATV del XML.
 *
 * Es la inversa de `toEdocumentPaymentWays` (`@utils/IvaDevuelto`), que traduce en la
 * direccion contraria al emitir. `InvoicePayment.formaPago` guarda el codigo interno, no el
 * de Hacienda, asi que la carga tiene que devolver el valor al dominio del sistema.
 *
 * El codigo ATV 99 esta asignado a dos formas internas (nota de debito y otros); para lo que
 * llega de un XML la que corresponde es "Otros".
 */
export const paymentWayFromAtvCode = (atvCode: string): number => {
    const normalized = `${atvCode || ""}`.padStart(2, "0");
    if (normalized === PAYMENT_METHODS[OTHER_PAYMENT_WAY_CODE].atvCode) return OTHER_PAYMENT_WAY_CODE;

    const match = Object.entries(PAYMENT_METHODS).find(([, method]) => method.atvCode === normalized);
    return match ? Number(match[0]) : OTHER_PAYMENT_WAY_CODE;
};

export const paymentWayLabel = (formaPago: number): string =>
    PAYMENT_METHODS[formaPago]?.label || PAYMENT_METHODS[OTHER_PAYMENT_WAY_CODE].label;
